<template>
  <div>
    <div>
      <h1 class="text-center">Survey Report</h1>
      <div>
        <ListSurveyReport />
      </div>
    </div>
  </div>
</template>

<script>
import ListSurveyReport from "@/views/Reports/Survey/ListSurveyReport.vue";
export default {
  components: {
    ListSurveyReport,
  },
};
</script>
